export const updateRoutes = (routesObject) => {
  return (dispatch) => {
    dispatch({ type: "UPDATE_ROUTES", payload: routesObject });
  };
};
